/* eslint-disable no-unused-vars */
import { Card, CardHeader, Box } from '@mui/material';
import { BaseOptionChart } from '../../../components/chart';

import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';

AppGraphsDonuts.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  name: PropTypes.string,
  chartData: PropTypes.array,
  chartLabels: PropTypes.arrayOf(PropTypes.string)
};

export default function AppGraphsDonuts({ title, subheader, chartLabels, chartData, ...other }) {
  const infosGraphsDonuts = {
    series: chartData,
    options: {
      legend: {
        show: true
      },
      stroke: {
        colors: ['#fff']
      },
      fill: {
        opacity: 0.8
      },
      plotOptions: {
        pie: {
          customScale: 0.9,
          donut: {
            size: 60,
            labels: {
              show: true,
              name: {
                show: false
              },
              value: {
                show: false
              },
              total: {
                show: false,
                label: 'Totalização'
              }
            }
          }
        }
      },
      labels: chartLabels
    }
  };

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 1, pb: 1 }} dir="ltr">
        <ReactApexChart
          type="donut"
          series={infosGraphsDonuts.series}
          options={infosGraphsDonuts.options}
          height={364}
        />
      </Box>
    </Card>
  );
}
